<template>
    <!-- Inizio repeater -->
    <tr>
        <td>{{ this.rigaScadenzario.DescrAttivita }}</td>
        <td>{{ this.rigaScadenzario.CodiceEntita }}</td>
        <td>{{ this.rigaScadenzario.DescrEntita }}</td>
        <td>{{ this.rigaScadenzario.NomeSito }}</td>
        <td>{{ this.rigaScadenzario.DescrUnita }}</td>
        <td>{{ this.rigaScadenzario.DescrReparto }}</td>
        <td>{{ this.rigaScadenzario.DescrComparto }}</td>        
        <td>{{ this.rigaScadenzario.Responsabile }}</td>
        <td class="InProgress">{{ this.formatDate(this.rigaScadenzario.DataProssima, format = 'DD/MM/YYYY')  }}</td>
    </tr>
    <!-- Fine repeater -->
</template>

<script>

import {dateMixin} from "/mixin.js";

export default {
    name: "RigaGrigliaScadenzario",
    props: {
        rigaScadenzario: Object
    },
    mixins: [dateMixin]
        
    
}
</script>